import { generateQueryParams2 } from 'utils'
import CommonService from './common.service'
import { _object, httpParams } from 'utils/interfaces'

class NewCustomerEntriesService extends CommonService {
  async getNewCustomers(params: httpParams = {}) {
    return await this.get(`/credit-applications?${generateQueryParams2(params)}`)
  }

  async AddNewCustomer(params: _object) {
    return await this.post('/credit-applications', params)
  }

  async getNewCustomerDetails(id: string | undefined) {
    return await this.get(`/credit-applications/${id}`)
  }

  async deletNewCustomer(id: string | undefined) {
    return await this.delete(`/credit-applications/${id}`)
  }

  async UpdateNewCustomer(id: string | undefined, params: { [key: string]: string }) {
    return await this.put(`/credit-applications/${id}`, params)
  }
}

export const newCustomerEntriesService = new NewCustomerEntriesService()
